import {
    Component,
    ViewEncapsulation,
    forwardRef,
    OnInit,
    Input,
    ContentChild,
    TemplateRef,
    ElementRef,
    SimpleChanges,
    OnChanges,
    ViewChild
} from '@angular/core';

import {
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
    FormControl,
    AbstractControl
} from '@angular/forms';

import { UUID } from '../../models/other/UUID';
import { OptionItem } from '../../models/other/option-item.model';
import { SearchThemeEnum } from '../../enums/search-theme.enum';
import { SearchComponent } from '../search/search.component';

@Component({
    selector: 'tk-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectComponent),
            multi: true
        }
    ]
})
export class SelectComponent implements OnInit, OnChanges, ControlValueAccessor {
    @ContentChild('itemTemplate') itemTemplate!: TemplateRef<{ $implicit: OptionItem | null }>;

    @Input() name?: string;
    @Input() formControl?: FormControl;
    @Input() options: Array<OptionItem> = [];
    @Input() styleClass: any;
    @Input() label?: string;
    @Input() onlyValue = false;
    @Input() placeholder = 'proszę wybrać';
    @Input() clearable = false;

    @Input()
    public showSearchInput: boolean;

    @ViewChild('select__toggle', { read: ElementRef }) selectButton: any;
    @ViewChild(SearchComponent) searchComponent: any;

    public showList = false;
    public disabled?: boolean;
    public searchThemeEnum = SearchThemeEnum;
    public filteredOptions: Array<OptionItem> = [];
    filterControl = new FormControl('');
    private _optionValue?: OptionItem;
    private searchInputHasFocus = false;
    private closeInterval: any;
    private searchPhrase: string;

    get optionValue(): OptionItem | null { 
        return this._optionValue ?? null;
    }

    set optionValue(val: OptionItem) {
        this._optionValue = val;
        this.label = val ? val.label : this.label;
        if (this.onlyValue === true) {
            if (this._optionValue) {
                this._onChange(this._optionValue.value);
            } else {
                this._onChange(null);
            }
        } else {
            this._onChange(this._optionValue);
        }
    }

    ngOnInit() {
        if (!this.name) {
            this.name = 'select_' + UUID.generate();
        }

        this.filterControl.valueChanges.subscribe(change => { this.filterOptions(change) });
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propertyName in changes) {
            if (propertyName === 'options') {
                const selectedItem = this.options.find(o => o.value === this.formControl?.value);
                this.optionValue = selectedItem as OptionItem;
                this.formControl?.markAsPristine();
                this.filterOptions(this.searchPhrase);
            }
        }
    }

    _onChange = (_: any) => { };
    _onTouched = (_: any) => { };

    writeValue(obj: any): void {
        if (obj !== undefined && obj !== null) {
            if (this.onlyValue === true) {
                for (let i = this.options.length - 1; i >= 0; i--) {
                    if (this.options[i].value === obj) {
                        this._optionValue = this.options[i];
                        break;
                    }
                }
            } else {
                this._optionValue = obj;
            }
        } else {
            this._optionValue = undefined;
        }
    }

    registerOnChange(fn: any): void { this._onChange = fn; }
    registerOnTouched(fn: any): void { this._onTouched = fn; }

    filterOptions(change: any): void {
        this.searchPhrase = (change || '').toLowerCase();

        if (this.searchPhrase !== '') {
            this.filteredOptions = this.options.filter(option => option.label?.toLowerCase().indexOf(this.searchPhrase) !== -1)
        } else {
            this.filteredOptions = this.options;
        }
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    toggleShowList() {
        this.showList = !this.showList;
        if (this.showList === true) {
            if (!this.showSearchInput) {
                this.selectButton.nativeElement.focus();
            } else {
                this.searchComponent.setFocus();
            }
        }
    }

    selectItem(item: OptionItem) {
        this.optionValue = item;
        this.showList = false;
        this.filterControl.setValue('', { onlySelf: true });
    }

    onArrowBlur() {
        if (!this.showSearchInput) {
            this.closeInterval = setTimeout(() => this.showList = false, 200);
        }
    }

    onSearchFocus(flag: boolean): void {
        this.searchInputHasFocus = flag;
        if (!this.searchInputHasFocus) {
            this.closeInterval = setTimeout(() => this.showList = false, 300);
        }
    }

    onSearchClear(): void {
        clearTimeout(this.closeInterval);
    }

    onSearchEnter(): void {

    }

    constructor() {
        this.showSearchInput = false;
        this.searchInputHasFocus = false;
        this.searchPhrase = '';
    }
}
